<template>
  <div>
    <DataTable
      :value="activityResults"
      :paginator="true"
      dataKey="contactId"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedActivityResults"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} activityResults"
    >
      <template #empty> No activity results found. </template>
      <template #loading> Loading activity results data. Please wait. </template>
      <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      <Column
        field="id"
        header="id"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.id }}
          </div>
        </template>
      </Column>
      <Column
        field="resultCode"
        header="Code"
        headerStyle="width: 5em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.resultCode }}
          </div>
        </template>
      </Column>
      <Column
        field="resultDesc"
        header="Description"
        headerStyle="width: 9em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.resultDesc }}
          </div>
        </template>
      </Column>
      <Column
        field="active"
        header="Is Active"
        headerStyle="width: 9em"
        :sortable="true"
      >
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 7em;">
        <template #body="slotProps">
          <div
            :style="{position: 'relative'}"
          >
            <SplitButton 
              label="Edit" 
              icon="pi pi-info" 
              class="p-button-success p-mb-2"
              @click="editActivityResult(slotProps.data)" 
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import PermissionMixin from '../../PermissionMixin.vue'
export default {
  mixins: [PermissionMixin],
  props: [
    'activityResults',
    'loading'
  ],
  data: () => ({
    selectedActivityResults: null,
    filters: {
      global: ''
    }
  }),
  created() {
    this.filters.global = this.$route.query.search
  },
  methods: {
    getButtons(data) {
      this.checkPermissions()
      let buttons = []
      if (this.deleteSettings) {
        buttons.push(
          {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
              this.deleteActivityResult(data)
            }
          }
        )
      }
      return buttons
    },
    deleteActivityResult(activityResult) {
      
    },
    editActivityResult(activityResult) {
      this.$emit('edit-activity-result', activityResult)
    }
  }
}
</script>

<style>

</style>